export { ArrowUp as default } from './ArrowUp';
